import { Route } from "vue-router";
import { restoreScrolls, scrollTo } from "@service/helpers/scrollHelper";

export const handleScrolls = (to: Route) => {
    to.name && restoreScrolls(to.name);

    if (to.params.scrollTo) {
        scrollTo(to.params.scrollTo)
    }
}
